import { t } from "i18next"

const SpecialNote = ({ value, onChange, label="Special instructions", placeholder="Leave an instruction note" }) => {
  return (
    <div>
      <label
        htmlFor="special-instructions"
        className="font-bold text-20x mb-4 block"
      >
        {t(label)}
      </label>
      <textarea
        id="special-instructions"
        className="bg-dark-blue-100 rounded-16x p-4 min-h-[100px] w-full text-lg focus:outline-none resize-none hide-resize placeholder:text-[#A1A4B1]"
        placeholder={t(placeholder)}
        value={value}
        onChange={onChange}
      />
    </div>
  )
}

export default SpecialNote